/**
 * Modexp accuracy curve data — generated by port-chart-data.mjs.
 * Do not edit by hand.
 *
 * 596 deduped probes across 45 (model, modulus) cells
 * merged from the curve runs (15_modexp_accuracy_curves) and the calibration
 * runs (14_modexp_calibration). Each cell's N varies — cal cells reach N=20,
 * curve cells are N=10.
 */

export type ModexpPoint = {
  readonly model: 'haiku' | 'sonnet' | 'opus';
  readonly modulus: number;
  readonly accuracy: number;
  readonly ciLo: number;
  readonly ciHi: number;
  readonly n: number;
  readonly passed: number;
  readonly avgTimeS: number;
};

export const MODEXP_CURVE_DATA: ReadonlyArray<ModexpPoint> = [
  {
    "model": "haiku",
    "modulus": 199,
    "accuracy": 1,
    "ciLo": 0.8865,
    "ciHi": 1,
    "n": 30,
    "passed": 30,
    "avgTimeS": 10.5
  },
  {
    "model": "haiku",
    "modulus": 307,
    "accuracy": 0.7,
    "ciLo": 0.3968,
    "ciHi": 0.8922,
    "n": 10,
    "passed": 7,
    "avgTimeS": 13.7
  },
  {
    "model": "haiku",
    "modulus": 503,
    "accuracy": 0.6,
    "ciLo": 0.3127,
    "ciHi": 0.8318,
    "n": 10,
    "passed": 6,
    "avgTimeS": 10.4
  },
  {
    "model": "haiku",
    "modulus": 521,
    "accuracy": 0.7667,
    "ciLo": 0.5907,
    "ciHi": 0.8821,
    "n": 30,
    "passed": 23,
    "avgTimeS": 13.5
  },
  {
    "model": "haiku",
    "modulus": 541,
    "accuracy": 0.7,
    "ciLo": 0.5212,
    "ciHi": 0.8334,
    "n": 30,
    "passed": 21,
    "avgTimeS": 216.3
  },
  {
    "model": "haiku",
    "modulus": 557,
    "accuracy": 0.5667,
    "ciLo": 0.392,
    "ciHi": 0.7262,
    "n": 30,
    "passed": 17,
    "avgTimeS": 14.6
  },
  {
    "model": "haiku",
    "modulus": 569,
    "accuracy": 0.8,
    "ciLo": 0.4902,
    "ciHi": 0.9433,
    "n": 10,
    "passed": 8,
    "avgTimeS": 14.7
  },
  {
    "model": "haiku",
    "modulus": 577,
    "accuracy": 0.5333,
    "ciLo": 0.3614,
    "ciHi": 0.6977,
    "n": 30,
    "passed": 16,
    "avgTimeS": 13.5
  },
  {
    "model": "haiku",
    "modulus": 593,
    "accuracy": 0.6333,
    "ciLo": 0.4551,
    "ciHi": 0.7813,
    "n": 30,
    "passed": 19,
    "avgTimeS": 12.9
  },
  {
    "model": "haiku",
    "modulus": 601,
    "accuracy": 0.9,
    "ciLo": 0.5958,
    "ciHi": 0.9821,
    "n": 10,
    "passed": 9,
    "avgTimeS": 19.3
  },
  {
    "model": "haiku",
    "modulus": 701,
    "accuracy": 0.5,
    "ciLo": 0.3315,
    "ciHi": 0.6685,
    "n": 30,
    "passed": 15,
    "avgTimeS": 14
  },
  {
    "model": "haiku",
    "modulus": 997,
    "accuracy": 0.3,
    "ciLo": 0.1666,
    "ciHi": 0.4788,
    "n": 30,
    "passed": 9,
    "avgTimeS": 15
  },
  {
    "model": "opus",
    "modulus": 500,
    "accuracy": 1,
    "ciLo": 0.4385,
    "ciHi": 1,
    "n": 3,
    "passed": 3,
    "avgTimeS": 11.7
  },
  {
    "model": "opus",
    "modulus": 2999,
    "accuracy": 0.7667,
    "ciLo": 0.5907,
    "ciHi": 0.8821,
    "n": 30,
    "passed": 23,
    "avgTimeS": 19.5
  },
  {
    "model": "opus",
    "modulus": 4999,
    "accuracy": 0.8,
    "ciLo": 0.6269,
    "ciHi": 0.905,
    "n": 30,
    "passed": 24,
    "avgTimeS": 226.8
  },
  {
    "model": "opus",
    "modulus": 7993,
    "accuracy": 0.7778,
    "ciLo": 0.5924,
    "ciHi": 0.8939,
    "n": 27,
    "passed": 21,
    "avgTimeS": 22.5
  },
  {
    "model": "opus",
    "modulus": 14983,
    "accuracy": 0.65,
    "ciLo": 0.4329,
    "ciHi": 0.8188,
    "n": 20,
    "passed": 13,
    "avgTimeS": 29.2
  },
  {
    "model": "opus",
    "modulus": 19997,
    "accuracy": 0.7,
    "ciLo": 0.3968,
    "ciHi": 0.8922,
    "n": 10,
    "passed": 7,
    "avgTimeS": 23.3
  },
  {
    "model": "opus",
    "modulus": 69997,
    "accuracy": 0.75,
    "ciLo": 0.5313,
    "ciHi": 0.8881,
    "n": 20,
    "passed": 15,
    "avgTimeS": 34.6
  },
  {
    "model": "opus",
    "modulus": 99991,
    "accuracy": 0.75,
    "ciLo": 0.5313,
    "ciHi": 0.8881,
    "n": 20,
    "passed": 15,
    "avgTimeS": 34.8
  },
  {
    "model": "opus",
    "modulus": 199999,
    "accuracy": 0.8,
    "ciLo": 0.4902,
    "ciHi": 0.9433,
    "n": 10,
    "passed": 8,
    "avgTimeS": 35.3
  },
  {
    "model": "opus",
    "modulus": 999983,
    "accuracy": 0.8,
    "ciLo": 0.3755,
    "ciHi": 0.9638,
    "n": 5,
    "passed": 4,
    "avgTimeS": 54.4
  },
  {
    "model": "opus",
    "modulus": 1999993,
    "accuracy": 0.8,
    "ciLo": 0.3755,
    "ciHi": 0.9638,
    "n": 5,
    "passed": 4,
    "avgTimeS": 84.8
  },
  {
    "model": "opus",
    "modulus": 4999999,
    "accuracy": 0.75,
    "ciLo": 0.3006,
    "ciHi": 0.9544,
    "n": 4,
    "passed": 3,
    "avgTimeS": 79.7
  },
  {
    "model": "opus",
    "modulus": 9999991,
    "accuracy": 1,
    "ciLo": 0.4385,
    "ciHi": 1,
    "n": 3,
    "passed": 3,
    "avgTimeS": 75.4
  },
  {
    "model": "opus",
    "modulus": 1000000000000037,
    "accuracy": 0.3333,
    "ciLo": 0.0615,
    "ciHi": 0.7923,
    "n": 3,
    "passed": 1,
    "avgTimeS": 113.4
  },
  {
    "model": "opus",
    "modulus": 100000000000000000000,
    "accuracy": 0,
    "ciLo": 0,
    "ciHi": 0.5615,
    "n": 3,
    "passed": 0,
    "avgTimeS": 65.2
  },
  {
    "model": "opus",
    "modulus": 1e+25,
    "accuracy": 0,
    "ciLo": 0,
    "ciHi": 0.5615,
    "n": 3,
    "passed": 0,
    "avgTimeS": 16.1
  },
  {
    "model": "opus",
    "modulus": 1e+30,
    "accuracy": 0,
    "ciLo": 0,
    "ciHi": 0.5615,
    "n": 3,
    "passed": 0,
    "avgTimeS": 13.6
  },
  {
    "model": "sonnet",
    "modulus": 503,
    "accuracy": 1,
    "ciLo": 0.7225,
    "ciHi": 1,
    "n": 10,
    "passed": 10,
    "avgTimeS": 12
  },
  {
    "model": "sonnet",
    "modulus": 2609,
    "accuracy": 1,
    "ciLo": 0.7225,
    "ciHi": 1,
    "n": 10,
    "passed": 10,
    "avgTimeS": 18.3
  },
  {
    "model": "sonnet",
    "modulus": 2699,
    "accuracy": 0.7,
    "ciLo": 0.3968,
    "ciHi": 0.8922,
    "n": 10,
    "passed": 7,
    "avgTimeS": 15.2
  },
  {
    "model": "sonnet",
    "modulus": 2753,
    "accuracy": 0.9,
    "ciLo": 0.5958,
    "ciHi": 0.9821,
    "n": 10,
    "passed": 9,
    "avgTimeS": 15.7
  },
  {
    "model": "sonnet",
    "modulus": 2801,
    "accuracy": 0.8,
    "ciLo": 0.4902,
    "ciHi": 0.9433,
    "n": 10,
    "passed": 8,
    "avgTimeS": 15.4
  },
  {
    "model": "sonnet",
    "modulus": 2903,
    "accuracy": 0.8,
    "ciLo": 0.4902,
    "ciHi": 0.9433,
    "n": 10,
    "passed": 8,
    "avgTimeS": 17.8
  },
  {
    "model": "sonnet",
    "modulus": 4999,
    "accuracy": 0.9,
    "ciLo": 0.5958,
    "ciHi": 0.9821,
    "n": 10,
    "passed": 9,
    "avgTimeS": 17.8
  },
  {
    "model": "sonnet",
    "modulus": 9973,
    "accuracy": 0.7,
    "ciLo": 0.3968,
    "ciHi": 0.8922,
    "n": 10,
    "passed": 7,
    "avgTimeS": 18.8
  },
  {
    "model": "sonnet",
    "modulus": 29989,
    "accuracy": 0.8,
    "ciLo": 0.3755,
    "ciHi": 0.9638,
    "n": 5,
    "passed": 4,
    "avgTimeS": 29
  },
  {
    "model": "sonnet",
    "modulus": 99991,
    "accuracy": 1,
    "ciLo": 0.5655,
    "ciHi": 1,
    "n": 5,
    "passed": 5,
    "avgTimeS": 38.6
  },
  {
    "model": "sonnet",
    "modulus": 299993,
    "accuracy": 0.4,
    "ciLo": 0.1176,
    "ciHi": 0.7693,
    "n": 5,
    "passed": 2,
    "avgTimeS": 27.3
  },
  {
    "model": "sonnet",
    "modulus": 999983,
    "accuracy": 0.4,
    "ciLo": 0.1176,
    "ciHi": 0.7693,
    "n": 5,
    "passed": 2,
    "avgTimeS": 40.7
  },
  {
    "model": "sonnet",
    "modulus": 2999999,
    "accuracy": 0.8,
    "ciLo": 0.3755,
    "ciHi": 0.9638,
    "n": 5,
    "passed": 4,
    "avgTimeS": 74.4
  },
  {
    "model": "sonnet",
    "modulus": 9999991,
    "accuracy": 0.6,
    "ciLo": 0.2307,
    "ciHi": 0.8824,
    "n": 5,
    "passed": 3,
    "avgTimeS": 92.1
  },
  {
    "model": "sonnet",
    "modulus": 29999999,
    "accuracy": 0.75,
    "ciLo": 0.3006,
    "ciHi": 0.9544,
    "n": 4,
    "passed": 3,
    "avgTimeS": 64.2
  },
  {
    "model": "sonnet",
    "modulus": 100000000000000000000,
    "accuracy": 0,
    "ciLo": 0,
    "ciHi": 0.5615,
    "n": 3,
    "passed": 0,
    "avgTimeS": 1128.1
  }
];

export const MODEXP_MODELS = ['haiku', 'sonnet', 'opus'] as const;

export const MODEL_COLORS: Record<string, string> = {
  haiku: '#6c757d',
  sonnet: '#2f7a6b',
  opus: '#1f3a5f',
};

export type ModexpTokenPoint = {
  readonly model: 'haiku' | 'sonnet' | 'opus';
  readonly modulus: number;
  readonly n: number;
  readonly partial: number;  // count of trials where session was killed mid-run (usage from assistant msg, not result record)
  readonly tokensMedian: number;
  readonly tokensP25: number;
  readonly tokensP75: number;
  readonly tokensMax: number;
  readonly durationMedianS: number;
};

/**
 * Per-(model, modulus) output-token stats, mined from every .conv.jsonl
 * tail across all modexp runs. Shows how much effort each trial took —
 * the complement to accuracy on the capability-curves section.
 */
export const MODEXP_TOKEN_DATA: ReadonlyArray<ModexpTokenPoint> = [
  {
    "model": "haiku",
    "modulus": 199,
    "n": 30,
    "partial": 0,
    "tokensMedian": 1812,
    "tokensP25": 1592,
    "tokensP75": 2036,
    "tokensMax": 2647,
    "durationMedianS": 9.9
  },
  {
    "model": "haiku",
    "modulus": 307,
    "n": 10,
    "partial": 0,
    "tokensMedian": 2267,
    "tokensP25": 2007,
    "tokensP75": 2827,
    "tokensMax": 4382,
    "durationMedianS": 14
  },
  {
    "model": "haiku",
    "modulus": 503,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1898,
    "tokensP25": 1696,
    "tokensP75": 2130,
    "tokensMax": 3062,
    "durationMedianS": 10
  },
  {
    "model": "haiku",
    "modulus": 521,
    "n": 30,
    "partial": 0,
    "tokensMedian": 2063,
    "tokensP25": 1745,
    "tokensP75": 2613,
    "tokensMax": 6306,
    "durationMedianS": 11.3
  },
  {
    "model": "haiku",
    "modulus": 541,
    "n": 29,
    "partial": 0,
    "tokensMedian": 2057,
    "tokensP25": 1856,
    "tokensP75": 2421,
    "tokensMax": 10622,
    "durationMedianS": 11.2
  },
  {
    "model": "haiku",
    "modulus": 557,
    "n": 30,
    "partial": 0,
    "tokensMedian": 2075,
    "tokensP25": 1665,
    "tokensP75": 2511,
    "tokensMax": 7765,
    "durationMedianS": 10.7
  },
  {
    "model": "haiku",
    "modulus": 569,
    "n": 10,
    "partial": 0,
    "tokensMedian": 2408,
    "tokensP25": 2211,
    "tokensP75": 2778,
    "tokensMax": 5138,
    "durationMedianS": 12.8
  },
  {
    "model": "haiku",
    "modulus": 577,
    "n": 31,
    "partial": 0,
    "tokensMedian": 2278,
    "tokensP25": 1791,
    "tokensP75": 2586,
    "tokensMax": 5651,
    "durationMedianS": 12.5
  },
  {
    "model": "haiku",
    "modulus": 593,
    "n": 30,
    "partial": 0,
    "tokensMedian": 1987,
    "tokensP25": 1805,
    "tokensP75": 2491,
    "tokensMax": 4264,
    "durationMedianS": 12.1
  },
  {
    "model": "haiku",
    "modulus": 601,
    "n": 10,
    "partial": 0,
    "tokensMedian": 2436,
    "tokensP25": 2107,
    "tokensP75": 3954,
    "tokensMax": 6882,
    "durationMedianS": 14.1
  },
  {
    "model": "haiku",
    "modulus": 701,
    "n": 30,
    "partial": 0,
    "tokensMedian": 2024,
    "tokensP25": 1743,
    "tokensP75": 2872,
    "tokensMax": 7159,
    "durationMedianS": 11.4
  },
  {
    "model": "haiku",
    "modulus": 997,
    "n": 30,
    "partial": 0,
    "tokensMedian": 2089,
    "tokensP25": 1808,
    "tokensP75": 2636,
    "tokensMax": 7604,
    "durationMedianS": 12
  },
  {
    "model": "opus",
    "modulus": 500,
    "n": 3,
    "partial": 0,
    "tokensMedian": 539,
    "tokensP25": 505,
    "tokensP75": 539,
    "tokensMax": 568,
    "durationMedianS": 10.2
  },
  {
    "model": "opus",
    "modulus": 2999,
    "n": 30,
    "partial": 0,
    "tokensMedian": 1011,
    "tokensP25": 860,
    "tokensP75": 1337,
    "tokensMax": 3325,
    "durationMedianS": 14.8
  },
  {
    "model": "opus",
    "modulus": 4999,
    "n": 29,
    "partial": 0,
    "tokensMedian": 1187,
    "tokensP25": 1013,
    "tokensP75": 1543,
    "tokensMax": 3098,
    "durationMedianS": 19.3
  },
  {
    "model": "opus",
    "modulus": 7993,
    "n": 27,
    "partial": 0,
    "tokensMedian": 1385,
    "tokensP25": 1125,
    "tokensP75": 1867,
    "tokensMax": 3342,
    "durationMedianS": 20.3
  },
  {
    "model": "opus",
    "modulus": 14983,
    "n": 20,
    "partial": 0,
    "tokensMedian": 1535,
    "tokensP25": 1340,
    "tokensP75": 2442,
    "tokensMax": 4313,
    "durationMedianS": 22.1
  },
  {
    "model": "opus",
    "modulus": 19997,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1657,
    "tokensP25": 1115,
    "tokensP75": 1759,
    "tokensMax": 2888,
    "durationMedianS": 21
  },
  {
    "model": "opus",
    "modulus": 69997,
    "n": 20,
    "partial": 0,
    "tokensMedian": 2271,
    "tokensP25": 1629,
    "tokensP75": 3053,
    "tokensMax": 6466,
    "durationMedianS": 27.5
  },
  {
    "model": "opus",
    "modulus": 99991,
    "n": 20,
    "partial": 0,
    "tokensMedian": 2314,
    "tokensP25": 1973,
    "tokensP75": 2719,
    "tokensMax": 4584,
    "durationMedianS": 32.3
  },
  {
    "model": "opus",
    "modulus": 199999,
    "n": 10,
    "partial": 0,
    "tokensMedian": 2446,
    "tokensP25": 2071,
    "tokensP75": 2737,
    "tokensMax": 4281,
    "durationMedianS": 29.1
  },
  {
    "model": "opus",
    "modulus": 999983,
    "n": 5,
    "partial": 0,
    "tokensMedian": 3784,
    "tokensP25": 3682,
    "tokensP75": 3790,
    "tokensMax": 5645,
    "durationMedianS": 52.3
  },
  {
    "model": "opus",
    "modulus": 1999993,
    "n": 5,
    "partial": 0,
    "tokensMedian": 6782,
    "tokensP25": 5200,
    "tokensP75": 6997,
    "tokensMax": 7579,
    "durationMedianS": 90.8
  },
  {
    "model": "opus",
    "modulus": 4999999,
    "n": 3,
    "partial": 1,
    "tokensMedian": 7381,
    "tokensP25": 4111,
    "tokensP75": 7381,
    "tokensMax": 12897,
    "durationMedianS": 98.9
  },
  {
    "model": "opus",
    "modulus": 9999991,
    "n": 3,
    "partial": 0,
    "tokensMedian": 6116,
    "tokensP25": 4714,
    "tokensP75": 6116,
    "tokensMax": 7154,
    "durationMedianS": 73.8
  },
  {
    "model": "opus",
    "modulus": 1000000000000037,
    "n": 3,
    "partial": 0,
    "tokensMedian": 926,
    "tokensP25": 429,
    "tokensP75": 926,
    "tokensMax": 20734,
    "durationMedianS": 20.4
  },
  {
    "model": "opus",
    "modulus": 100000000000000000000,
    "n": 3,
    "partial": 0,
    "tokensMedian": 3327,
    "tokensP25": 974,
    "tokensP75": 3327,
    "tokensMax": 6330,
    "durationMedianS": 60.2
  },
  {
    "model": "opus",
    "modulus": 1e+25,
    "n": 3,
    "partial": 0,
    "tokensMedian": 751,
    "tokensP25": 459,
    "tokensP75": 751,
    "tokensMax": 915,
    "durationMedianS": 14.4
  },
  {
    "model": "opus",
    "modulus": 1e+30,
    "n": 3,
    "partial": 0,
    "tokensMedian": 381,
    "tokensP25": 366,
    "tokensP75": 381,
    "tokensMax": 859,
    "durationMedianS": 9
  },
  {
    "model": "sonnet",
    "modulus": 503,
    "n": 10,
    "partial": 0,
    "tokensMedian": 832,
    "tokensP25": 667,
    "tokensP75": 912,
    "tokensMax": 987,
    "durationMedianS": 10.4
  },
  {
    "model": "sonnet",
    "modulus": 2609,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1154,
    "tokensP25": 906,
    "tokensP75": 1460,
    "tokensMax": 2719,
    "durationMedianS": 13
  },
  {
    "model": "sonnet",
    "modulus": 2699,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1047,
    "tokensP25": 956,
    "tokensP75": 1304,
    "tokensMax": 2195,
    "durationMedianS": 12.7
  },
  {
    "model": "sonnet",
    "modulus": 2753,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1267,
    "tokensP25": 1225,
    "tokensP75": 1322,
    "tokensMax": 1488,
    "durationMedianS": 14.4
  },
  {
    "model": "sonnet",
    "modulus": 2801,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1100,
    "tokensP25": 1042,
    "tokensP75": 1277,
    "tokensMax": 1856,
    "durationMedianS": 13.5
  },
  {
    "model": "sonnet",
    "modulus": 2903,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1143,
    "tokensP25": 1029,
    "tokensP75": 1425,
    "tokensMax": 3553,
    "durationMedianS": 14.9
  },
  {
    "model": "sonnet",
    "modulus": 4999,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1153,
    "tokensP25": 995,
    "tokensP75": 1680,
    "tokensMax": 3194,
    "durationMedianS": 13.7
  },
  {
    "model": "sonnet",
    "modulus": 9973,
    "n": 10,
    "partial": 0,
    "tokensMedian": 1528,
    "tokensP25": 1178,
    "tokensP75": 1705,
    "tokensMax": 2700,
    "durationMedianS": 16.5
  },
  {
    "model": "sonnet",
    "modulus": 29989,
    "n": 5,
    "partial": 0,
    "tokensMedian": 3507,
    "tokensP25": 1637,
    "tokensP75": 3941,
    "tokensMax": 5186,
    "durationMedianS": 32.4
  },
  {
    "model": "sonnet",
    "modulus": 99991,
    "n": 5,
    "partial": 0,
    "tokensMedian": 3948,
    "tokensP25": 2801,
    "tokensP75": 4134,
    "tokensMax": 5527,
    "durationMedianS": 36.6
  },
  {
    "model": "sonnet",
    "modulus": 299993,
    "n": 5,
    "partial": 0,
    "tokensMedian": 2053,
    "tokensP25": 1941,
    "tokensP75": 2715,
    "tokensMax": 3735,
    "durationMedianS": 25.1
  },
  {
    "model": "sonnet",
    "modulus": 999983,
    "n": 4,
    "partial": 0,
    "tokensMedian": 3187,
    "tokensP25": 2194,
    "tokensP75": 6467,
    "tokensMax": 8893,
    "durationMedianS": 30.5
  },
  {
    "model": "sonnet",
    "modulus": 2999999,
    "n": 5,
    "partial": 0,
    "tokensMedian": 5753,
    "tokensP25": 5378,
    "tokensP75": 8588,
    "tokensMax": 11980,
    "durationMedianS": 62.7
  },
  {
    "model": "sonnet",
    "modulus": 9999991,
    "n": 5,
    "partial": 0,
    "tokensMedian": 9143,
    "tokensP25": 6118,
    "tokensP75": 11357,
    "tokensMax": 11643,
    "durationMedianS": 103
  },
  {
    "model": "sonnet",
    "modulus": 29999999,
    "n": 4,
    "partial": 0,
    "tokensMedian": 5596,
    "tokensP25": 3170,
    "tokensP75": 7372,
    "tokensMax": 7671,
    "durationMedianS": 63.8
  },
  {
    "model": "sonnet",
    "modulus": 100000000000000000000,
    "n": 3,
    "partial": 0,
    "tokensMedian": 128000,
    "tokensP25": 79401,
    "tokensP75": 128000,
    "tokensMax": 128000,
    "durationMedianS": 1273.7
  }
];
